import { Dispatch, SetStateAction, useState } from 'react';
import { QueryObserverResult } from '@tanstack/react-query';
import OrganisationTreeNode from 'shared/features/organisation/models/organisation-tree-node';

type OrganisationUnitTreeState = {
  organisationUnitTree?: OrganisationTreeNode[];
  error?: Error | null;
  isLoading: boolean;
  isSuccess: boolean;
  isFetching: boolean;
  refetch?: () => Promise<QueryObserverResult<OrganisationTreeNode[], Error>>;
};

export type OrganisationUnitTreeProviderState = OrganisationUnitTreeState & {
  setOrganisationUnitTreeState?: Dispatch<SetStateAction<OrganisationUnitTreeState>>;
};

const useOrganisationUnitTreeState = (): OrganisationUnitTreeProviderState => {
  const [organisationUnitTreeState, setOrganisationUnitTreeState] = useState<OrganisationUnitTreeState>({
    isLoading: false,
    isFetching: false,
    isSuccess: false,
    refetch: {} as never,
  });

  return {
    ...organisationUnitTreeState,
    setOrganisationUnitTreeState,
  };
};

export default useOrganisationUnitTreeState;
